import styles from "./SelectDark.module.scss";
import cn from "clsx";

interface SelectProps {
  isFullWidth?: boolean;
  value: string;
  onChangeFunc: (value: string) => void;
  options: string[];
  disabled?: boolean;
  onBlur?: () => void;
  isDark?: boolean;
}

export default function SelectDark({
  isFullWidth = true,
  value,
  onChangeFunc,
  options,
  disabled = false,
  onBlur,
  isDark = true,
}: SelectProps) {
  return (
    <div
      className={cn(styles.SelectContainer, {
        "w-full": isFullWidth,
      })}
    >
      <select
        className={cn({
          [styles.Select__Field_Dark]: isDark,
        })}
        value={value}
        onChange={(e) => onChangeFunc(e.target.value)}
        disabled={disabled}
        onBlur={onBlur}
      >
        {options.map((option, i) => (
          <option value={option} key={i}>
            {option}
          </option>
        ))}
      </select>
      <div className={styles.Select__Arrow}>
        <svg
          width="13"
          height="9"
          viewBox="0 0 13 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 1L6.62222 7L0.999999 1"
            stroke="#fff"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </div>
  );
}

